import { fetchReader, fetchWriter, Api, subscribeComponentFactory } from '@artsman/ams-loader';

import { auth } from './auth';
import dataSources from './dataSources';
import { getEndpoint, loader, channels } from './loading';

/*
 * API REDUCER
 *
 * Create main API loading reducer.  This manages loading JS modules, reading API data, writing API data, and
 * updating data after server-side push events via the WebSocket.
 */
export const api = new Api(
  'api',
  dataSources,
  loader,
  fetchReader(getEndpoint),
  fetchWriter(getEndpoint),
  {
    authenticator: auth,
    connectSubscriber: subscribeComponentFactory(channels)
  }
);

/*
 * SOCKET ACTION CREATORS
 *
 * Action types and action creators for socket connect/disconnect actions
 */
const SOCKET_STATE_KEY = 'socket';
const SOCKET_CONNECT = 'SOCKET_CONNECT';
const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
const SOCKET_STATE_CONNECTED = 'connected';
const SOCKET_STATE_DISCONNECTED = 'disconnected';

export function connectSocket() {
  return { type: SOCKET_CONNECT }
}

export function disconnectSocket() {
  return { type: SOCKET_DISCONNECT }
}

/*
 * SOCKET SELECTORS
 *
 * Selector for getting the current socket state
 */
export function isConnected(state) {
  return state[SOCKET_STATE_KEY] == SOCKET_STATE_CONNECTED;
}

/*
 * SOCKET REDUCER
 *
 * Simple reducer to push the connected/disconencted state of the socket into the UI so that React can inform
 * the user when the server has been disconnected.
 */
function socket(state = SOCKET_STATE_DISCONNECTED, action) {
  switch (action.type) {
    case SOCKET_CONNECT:
      return SOCKET_STATE_CONNECTED;
    case SOCKET_DISCONNECT:
      return SOCKET_STATE_DISCONNECTED;
    default:
      return state
  }
}

export default {
  [api.stateKey]: api.reducer,
  [SOCKET_STATE_KEY]: socket
}